module.exports = __webpack_public_path__ + "img/emoticon-csat-2-off.95fc254c.svg";